import { render } from "./TruncateInput.vue?vue&type=template&id=3a958259&scoped=true&ts=true"
import script from "./TruncateInput.vue?vue&type=script&lang=ts"
export * from "./TruncateInput.vue?vue&type=script&lang=ts"

import "./TruncateInput.vue?vue&type=style&index=0&id=3a958259&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a958259"]])

export default __exports__